// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const customValueByUS = (value: any ) => {
  return (value * 1).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  })
}